import { createFileRoute } from "@tanstack/react-router";
import { TenantHome } from "@/features/tenant/TenantHome";

export const Route = createFileRoute("/app/tenant/")({ component: TenantHome });
